import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_c(VCard,[_c(VCardTitle,{staticClass:"text-h5"},[_vm._v(" Eliminar ")]),_c(VCardText,{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.title))]),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"secondary","text":""},on:{"click":function($event){return _vm.$emit('closeFnc')}}},[_vm._v(" Cancelar ")]),_c(VBtn,{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('deleteFnc')}}},[_vm._v(" Borrar ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }